import { styled } from '@mui/material';

export const PartnerLabel = styled('strong')(({ theme }) => ({
  color: theme.palette.text.primary
}));
